
import { Badge } from "@/components/ui/badge";

interface ConversationStatusBadgeProps {
  status: string;
}

export const ConversationStatusBadge = ({ status }: ConversationStatusBadgeProps) => {
  const statusLower = status.toLowerCase();
  
  if (statusLower === "completed" || statusLower === "done") {
    return <Badge variant="default" className="bg-green-500">Completed</Badge>;
  } else if (statusLower === "in_progress" || statusLower === "in-progress") {
    return <Badge variant="default" className="bg-blue-500">In Progress</Badge>;
  } else if (statusLower === "failed" || statusLower === "error" || statusLower === "failure") {
    return <Badge variant="destructive">Failed</Badge>;
  } else if (statusLower === "no_answer" || statusLower === "no-answer") {
    return <Badge variant="outline">No Answer</Badge>;
  }
  
  return <Badge variant="secondary">{status}</Badge>;
};
